import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { SimpleChipItem } from "@similarweb/ui-components";

export const StyledSuggestedSimpleChipItem = styled(SimpleChipItem)`
    padding-right: 4px;
    background-color: transparent;
    border: 1px solid ${colorsPalettes.carbon[300]};
    box-sizing: border-box;

    svg {
        width: 12px;
        height: 12px;

        path {
            fill: ${colorsPalettes.carbon[250]};
        }
    }
`;
